export default String.raw`
$(document).ready(function() {
    const $form = $(".newsletter-form-js");
    if ($form.length === 0) {
        return;
    }

    const $button = $form.find("button");

    $button.on("click", async () => {
        let conditions = true;
        const $tosesRequired = $form.find("input[name='tos']:required");
        if ($tosesRequired.length > 0) {
            for (const obj of $tosesRequired) {
                const $obj = $(obj);
                if (!$obj.is(":checked")) {
                    $obj.parent().find("label").addClass("validation-error-js");
                }
            }

            for (const obj of $tosesRequired) {
                const $obj = $(obj);
                if (!$obj.is(":checked")) {
                    conditions = false;
                    app.temporaryPopupMessage(undefined, __translations.NewsLetter_Err2, "err");
                    break;
                }
            }
        }

        const $email = $form.find("input[type='email']");

        if ($email.hasClass("validation-error-js") || $email.val() === "") {
            conditions = false;
            app.temporaryPopupMessage(undefined, __translations.NewsLetter_Err1, "err");

            if (!$email.hasClass("validation-error-js")) {
                $email.addClass("validation-error-js");
            }
        }

        if (conditions) {
            const $toses = $form.find("input[name='tos']:checked");
            const $channels = $form.find("input[name='channel']");

            const email = $email.val();
            const data = [];
            const keys = [];
            data.push({name: 'email', value: email});

            $toses.each((_i, obj) => {
                const $obj = $(obj);
                data.push({ name: 'tos', value: $obj.val().toString()});
            });

            $channels.each((_i, obj) => {
                const $obj = $(obj);
                keys.push($obj.val());
            });

            data.push({name: 'channelKey', value: keys.toString()});
            data.push({name: '__action', value: "Newsletter/Subscribe"});
            data.push({name: '__csrf', value: __CSRF});

            $.post(null, data, (mess)=>{
                if (mess.action.Type === "msg") {
                    app.temporaryPopupMessage(undefined, mess.action.Message, "msg");
                    $form.find("input[name='email']").val("");
                    $form.find("input[type='checkbox']").prop("checked", false);
                    const dialog = document.querySelector('.popup-timer-js');
                    if (dialog?.open) {
                        dialog.close();
                    }
                } else {
                    app.temporaryPopupMessage(undefined, mess.action.Message, "err");
                }
            });
        }
    });
});
`